/**
 * visuels.js — Bibliothèque des 12 infographies pédagogiques
 * du parcours Permis AM · option Voiturette / Quadricycle léger à moteur.
 *
 * Chaque visuel est numéroté (1..12) et rangé par séquence pédagogique
 * pour être appelé directement depuis les pages de séquences.
 *
 * Convention :
 *   - Les 4 premiers (1-4) sont utilisés à la fois comme poster de séquence
 *     sur le Hub ET comme infographie de contenu.
 *   - Les 8 suivants (5-12) enrichissent le contenu des séquences 2, 4 et 5.
 */

const IMG_BASE = '/images/voiturette';

export const VISUELS = {
  1: {
    id: 1,
    src: `${IMG_BASE}/voiturette-1-decouvre.png`,
    title: 'Découvre ma voiturette',
    subtitle: 'Apprends à connaître ton véhicule',
    caption: "Caractéristiques d'une voiturette AM · commandes, éclairage, ceinture, pneus, freins.",
    color: '#0891b2',
    kicker: 'Visuel 1',
  },
  2: {
    id: 2,
    src: `${IMG_BASE}/voiturette-2-regarder-controler.png`,
    title: 'Regarder · Contrôler · Anticiper',
    subtitle: 'Ta routine avant de démarrer',
    caption: 'Regarde, contrôle, signale, vérifie, démarre — les 5 étapes avant chaque départ.',
    color: '#22c55e',
    kicker: 'Visuel 2',
  },
  3: {
    id: 3,
    src: `${IMG_BASE}/voiturette-3-freiner-arreter.png`,
    title: 'Freiner et s\'arrêter',
    subtitle: 'Une bonne maîtrise pour ta sécurité',
    caption: 'J’anticipe · je relâche · je freine · je m’arrête. Bonnes pratiques + à éviter.',
    color: '#f59e0b',
    kicker: 'Visuel 3',
  },
  4: {
    id: 4,
    src: `${IMG_BASE}/voiturette-4-difference-vitesse.png`,
    title: 'La différence de vitesse',
    subtitle: 'Anticipe et facilite la compréhension de tes intentions',
    caption: '45 km/h vs 80 km/h · pour ta sécurité et les risques du différentiel.',
    color: '#e11d48',
    kicker: 'Visuel 4',
  },
  5: {
    id: 5,
    src: `${IMG_BASE}/voiturette-5-maitriser-vehicule.png`,
    title: 'Maîtriser le véhicule',
    subtitle: 'Hors circulation',
    caption: 'Démarrer / s’arrêter · maintenir une trajectoire · tourner · marche arrière.',
    color: '#0ea5e9',
    kicker: 'Visuel 5',
  },
  6: {
    id: 6,
    src: `${IMG_BASE}/voiturette-6-stationner.png`,
    title: 'Stationner',
    subtitle: 'Les trois types de stationnement',
    caption: 'En épi · en bataille · en créneau — je prends le temps d’observer, signaler, contrôler.',
    color: '#a855f7',
    kicker: 'Visuel 6',
  },
  7: {
    id: 7,
    src: `${IMG_BASE}/voiturette-7-observer-communiquer.png`,
    title: 'Observer et communiquer',
    subtitle: 'Voir, être vu, se faire comprendre',
    caption: 'Observer loin · adapter son allure · surveiller rétros et angles morts · contrôler.',
    color: '#22c55e',
    kicker: 'Visuel 7',
  },
  8: {
    id: 8,
    src: `${IMG_BASE}/voiturette-8-intersections.png`,
    title: 'Intersections',
    subtitle: 'Identifier · anticiper · décider',
    caption: '6 étapes : je repère, je vérifie, j’identifie les priorités, j’observe, j’adapte, je m’engage.',
    color: '#f97316',
    kicker: 'Visuel 8',
  },
  9: {
    id: 9,
    src: `${IMG_BASE}/voiturette-9-giratoires.png`,
    title: 'Les giratoires',
    subtitle: 'Bien se positionner',
    caption: 'M’insérer en observant · rester au centre de ma voie · sortir avec mon clignotant.',
    color: '#0ea5e9',
    kicker: 'Visuel 9',
  },
  10: {
    id: 10,
    src: `${IMG_BASE}/voiturette-10-difference-vitesse-detaillee.png`,
    title: 'La différence de vitesse',
    subtitle: 'Être attentif aux autres véhicules',
    caption: '45 km/h vs 80 km/h · +35 km/h de différence · les autres arrivent plus vite que prévu.',
    color: '#f43f5e',
    kicker: 'Visuel 10',
  },
  11: {
    id: 11,
    src: `${IMG_BASE}/voiturette-11-meteo-visibilite.png`,
    title: 'Météo et visibilité',
    subtitle: 'Adapter sa conduite',
    caption: 'Pluie · brouillard · nuit · fort soleil — j’adapte vitesse, distances et éclairage.',
    color: '#6366f1',
    kicker: 'Visuel 11',
  },
  12: {
    id: 12,
    src: `${IMG_BASE}/voiturette-12-risques-quotidien.png`,
    title: 'Les risques du quotidien',
    subtitle: 'Pour une conduite responsable',
    caption: 'Téléphone · alcool · pression des copains · vitesse · fatigue · entretien.',
    color: '#a855f7',
    kicker: 'Visuel 12',
  },
};

/** Regroupement par séquence — pratique pour afficher galerie ou carrousel. */
export const VISUELS_PAR_SEQUENCE = {
  representations: [VISUELS[1]],
  'hors-circulation': [VISUELS[2], VISUELS[5]],
  code: [VISUELS[3]],
  circulation: [
    VISUELS[7], VISUELS[6], VISUELS[8], VISUELS[9],
    VISUELS[4], VISUELS[10], VISUELS[11],
  ],
  sensibilisation: [VISUELS[12]],
};

export function getVisuel(num) {
  return VISUELS[num] || null;
}

export default VISUELS;
